import { FC } from 'react'
import { ContentListItem, FeedbackCard, FeedbackCardState } from '@enbw/ui-react'
import { useTranslation } from 'react-i18next'
import { TerminationReason } from './TerminationReason'
import { TerminatedMessage } from '@/domain/contract/types/messages'
import { formatDate, FormattedDateMode } from '@/util/date-util'
import { TerminatedBy } from '@/domain/contract/layouts/ContractDetailsLayout/components/ContractMessagesFlyout/components/TerminatedBy'

type TerminatedMessageCardProps = {
  message: TerminatedMessage
}

export const TerminatedMessageCard: FC<TerminatedMessageCardProps> = ({ message }) => {
  const { t } = useTranslation()

  return (
    <FeedbackCard state={FeedbackCardState.Error} title={t('contract.messagesFlyout.TerminatedMessage.title')}>
      <div slot="description">
        <ContentListItem label={t('contract.messagesFlyout.fields.reason')}>
          <div slot="body">
            <TerminationReason reason={message.reason} />
          </div>
        </ContentListItem>
        <ContentListItem label={t('contract.messagesFlyout.fields.terminationDate')} body={formatDate(message.terminationDate, FormattedDateMode.Date)} />
        <ContentListItem label={t('contract.messagesFlyout.fields.terminatedBy')}>
          <div slot="body">
            <TerminatedBy terminatedBy={message.terminatedBy} terminatedByType={message.terminatedByType} reason={message.reason} />
          </div>
        </ContentListItem>
      </div>
    </FeedbackCard>
  )
}
